import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@components/ui/Button';

const VisionForFuture = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        {/* Call to Action */}
        <div className="text-center">
          <div className="bg-[#f5f6fa] rounded-3xl p-8 lg:p-12 border border-[#08005f] border-opacity-10">
            <h3
              className="font-heading font-bold text-2xl lg:text-3xl mb-4"
              style={{ color: "#08005f" }}
            >
              Be Part of Our Vision
            </h3>
            <p className="text-text-secondary leading-relaxed mb-8 max-w-2xl mx-auto">
              Join us in transforming eye care across East Africa. Whether as a patient, partner, 
              or supporter, you can be part of creating a future where everyone has access to 
              exceptional vision care.
            </p>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact-multi-channel-communication-hub">
                <Button
                  variant="default"
                  size="lg"
                  iconName="MessageCircle"
                  iconPosition="left"
                  iconSize={20}
                  className="bg-[#08005f] hover:bg-[#eb2227] border-none text-white"
                >
                  Partner With Us
                </Button>
              </Link>
              <Link to="/services-comprehensive-eye-care-universe">
                <Button
                  variant="outline"
                  size="lg"
                  iconName="Eye"
                  iconPosition="left"
                  iconSize={20}
                  className="border-[#08005f] text-[#08005f] hover:bg-[#eb2227] hover:text-white"
                >
                  Explore Our Services
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionForFuture;
